const { Auth, API } = require('aws-amplify');

const apiRequest = ({ service = 'app', path, method = 'GET', ...kwargs }) =>
   Auth.currentSession()
      .then((session) => session.getIdToken().getJwtToken())
      .then((token) =>
         API[method === 'DELETE' ? 'del' : method.toLowerCase()](
            service,
            path,
            {
               headers: { Authorization: `Bearer ${token}` },
               ...kwargs,
            }
         )
      );

export { apiRequest };
